var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow > -1
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow(-1);
      }
    }
  }, [_vm.dataToShow == 1 ? _c('div', [_c('div', {
    staticClass: "my-5 mx-5 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n        Ajouter un référent\n      ")]), _vm._v(" "), _c('div', [_c('h6', {
    staticClass: "w-full text-center text-indigo-600 mb-10"
  }, [_vm._v("\n          Veuillez saisir les informations du nouveau référent à ajouter\n        ")]), _vm._v(" "), _c('form', {
    staticClass: "grid grid-cols-2 gap-x-4 gap-y-10 mb-10",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('input-text', {
    staticClass: "md:col-span-1",
    attrs: {
      "name": "Prénom",
      "libelle": "Prénom",
      "value": _vm.referentToEdit.firstname,
      "error": true,
      "msg-error": ((_vm.errors || []).firstname || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.firstname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-1",
    attrs: {
      "name": "Nom",
      "libelle": "Nom",
      "value": _vm.referentToEdit.lastname,
      "error": true,
      "msg-error": ((_vm.errors || []).lastname || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.lastname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-1",
    attrs: {
      "libelle": "Email",
      "value": _vm.referentToEdit.newMail,
      "msg-error": ((_vm.errors || []).newMail || [])[0],
      "error": true
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.newMail = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-1",
    attrs: {
      "name": "Role",
      "libelle": "Role par défaut",
      "value": _vm.referentToEdit.newRole,
      "datas": _vm.listRoles,
      "error": true,
      "msg-error": ((_vm.errors || []).newRole || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.newRole = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.saving ? _c('div', {
    staticClass: "w-max-content w-max"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER",
      "spinner": true,
      "right": true,
      "type-shadow": "shadow-pink"
    }
  })], 1) : _c('div', {
    staticClass: "w-max-content w-max"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER",
      "icon": "arrow-right_1",
      "right": true,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.confirmCreateReferent();
      }
    }
  })], 1)])]), _vm._v(" "), _c('h5', {
    staticClass: "my-10"
  }, [_vm._v("\n        OU\n      ")]), _vm._v(" "), _c('div', [_c('h6', {
    staticClass: "w-full text-center text-indigo-600 mb-10"
  }, [_vm._v("\n          Si vous souhaitez ajouter un référent existant,\n          "), _c('br'), _vm._v("\n          veuillez saisir l’identifiant ou l’adresse email du référent\n        ")]), _vm._v(" "), _c('form', {
    staticClass: "grid grid-cols-11 gap-x-4 gap-y-10 mb-10",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input-text', {
    staticClass: "lg:col-span-5",
    attrs: {
      "libelle": "Identifiant",
      "value": _vm.referentToEdit.username,
      "error": true,
      "msg-error": ((_vm.errors || []).username || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.username = newValue;
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-span-1 place-self-center mt-5 text-indigo-600"
  }, [_vm._v("OU")]), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-5",
    attrs: {
      "libelle": "Email",
      "value": _vm.referentToEdit.existingMail,
      "error": true,
      "msg-error": ((_vm.errors || []).existingMail || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.existingMail = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-5",
    attrs: {
      "name": "RoleAttach",
      "libelle": "Role par défaut",
      "value": _vm.referentToEdit.existingRole,
      "datas": _vm.listRoles,
      "error": true,
      "msg-error": ((_vm.errors || []).existingRole || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.existingRole = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.saving ? _c('div', {
    staticClass: "col-span-full justify-self-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER",
      "spinner": true,
      "right": true,
      "type-shadow": "shadow-pink"
    }
  })], 1) : _c('div', {
    staticClass: "col-span-full justify-self-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER",
      "icon": "plus-circle",
      "right": true,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": _vm.linkReferent
    }
  })], 1)])])])]) : _vm.dataToShow == 2 ? _c('div', [_c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "w-full text-pink-600 mb-10"
  }, [_vm._v("\n        Référent créé !\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          L’invitation a été transmise à " + _vm._s(_vm.referentToEdit.firstname) + "\n          "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.referentToEdit.lastname))]), _vm._v(", à l'adresse email " + _vm._s(_vm.referentToEdit.email) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Vous pourrez lui attribuer des carnets de parcours seulement après\n          sa validation.\n        ")])]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "basket"
    }
  })], 1)]) : _vm.dataToShow == 3 ? _c('div', [_c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "w-full text-pink-600 mb-10"
  }, [_vm._v("\n        Référent rattaché !\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          L’invitation a été transmise à " + _vm._s(_vm.referentToEdit.username) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Vous pourrez lui attribuer des Neopass seulement après sa\n          validation.\n        ")])]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "basket"
    }
  })], 1)]) : _vm.dataToShow == 100 ? _c('div', [_c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "w-full text-pink-600 mb-10"
  }, [_vm._v("\n        Erreur lors de la création du référent !\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Le référent n'a pas pu être créé.\n        ")])]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "notAllowed"
    }
  })], 1)]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }